import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarHeaderNavigationService {

  constructor() { }

 private actionSource = new Subject<string>();

  action = this.actionSource.asObservable();

  emitAction(action: string): void {
    this.actionSource.next(action);
  }
}
